import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Accounts } from '../../../../enum';
import { ArDocModalWithToggle } from '../../../../../shared';
import { useAccountDocumentArDocHasFileName, useAccountDocumentArDocId } from '../../../hooks';

export const AccountsDocumentsArDocFileName = (props: {
  size?: string | number | undefined,
  transform?: ouiStyle.InStyle['transform'],
  color?: ouiStyle.Constants.Colors,
}) => {
  const {
    size,
    transform,
    color,
  } = props;
  const {
    data: hasFileName,
    isLoading,
  } = useAccountDocumentArDocHasFileName();
  const { data: arDocId } = useAccountDocumentArDocId();
  return (
    <ArDocModalWithToggle
      service={Accounts.Documents}
      hasFileName={hasFileName}
      isLoading={isLoading}
      arDocId={arDocId}
      size={size}
      transform={transform}
      color={color}
    />
  );
};
